const EXPECTED_VALUE = '1'
const KEY_NAME = 'jbs-auth-version'

export default async ctx => {
  const actualValue = localStorage.getItem(KEY_NAME)
  if (actualValue === EXPECTED_VALUE) return
  await ctx.$telemetry().catch(() => null)
  localStorage.clear()
  localStorage.setItem(KEY_NAME, EXPECTED_VALUE)
  await navigator.serviceWorker
    .getRegistrations()
    .then(registrations =>
      Promise.all(
        registrations.map(registration =>
          registration.unregister().catch(() => null)
        )
      )
    )
    .catch(() => null)
  window.location.reload()
}
